import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import AuthLayout from "src/component/navigation/publicNavbar";
import CommercialPropertyInformationScreen from "src/pages/innerPages/CRM/commercialPropertyDetails/CommercialPropertyInformationScreen";
import PgPropertyInformationScreen from "src/pages/innerPages/CRM/pgPropertyDetails/pgPropertyInformation";
import RecidentialPropertyInformationScreen from "src/pages/innerPages/CRM/residentialPropertyDetails/recidentialPropertyInformationScreen";
import LinkedInCallback from "src/pages/outerPages/LinkedInCallback/LinkedInCallback";

const HomeScreen = lazy(() => import("src/pages/outerPages/home/home"));

const PrivacyPolicyScreen = lazy(
  () => import("src/pages/outerPages/privacyPolicy/privacyPolicyScreen")
);

const TermsConditionsScreen = lazy(
  () => import("src/pages/outerPages/termsConditions/termsConditionsScreen")
);

const ListPropertyScreen = lazy(
  () => import("src/pages/outerPages/listProperty/listPropertyScreen")
);

const SignInScreen = lazy(
  () => import("src/pages/outerPages/signIn/signInScreen")
);

const LoginScreen = lazy(
  () => import("src/pages/outerPages/CRM/crmLogin/loginScreen")
);

const PropertySerachScreen = lazy(
  () => import("src/pages/outerPages/propertySearch/propertySearchScreen")
);

const DashboardScreen = lazy(
  () => import("src/pages/innerPages/CRM/dashboard/dashboardScreen")
);

const EnquiryReportScreen = lazy(
  () => import("src/pages/innerPages/CRM/enquiryReport/enquiryReportScreen")
);

const SMSSettingAddScreen = lazy(
  () => import("src/pages/sms/smsSettingAddScreen")
);

const SMSSettingReport = lazy(
  () => import("src/pages/sms/smsSettingReport")
);

const MessageSettingAddScreen = lazy(
  () => import("src/pages/innerPages/message_setting/messageSettingScreen")
);

const ResidentialPropertyDetailsScreen = lazy(
  () => import("src/pages/innerPages/CRM/residentialPropertyDetails/residentialPropertyDetailsScreen")
);

const CommercialPropertyDetailsScreen = lazy(
  () => import("src/pages/innerPages/CRM/commercialPropertyDetails/commercialPropertyDetailsScreen")
);

const PgPropertyDetailsScreen = lazy(
  () => import("src/pages/innerPages/CRM/pgPropertyDetails/pgPropertyDetailsScreen")
);

const SearchPropertyFilterScreen = lazy(
  () => import("src/pages/outerPages/searchPropertyFilter/searchPropertyFilterScreen")
);
const SearchPropertyListScreen = lazy(
  () => import("src/pages/outerPages/searchPropertyList/searchPropertyListScreen")
);
const SearchPropertyDetailsScreen = lazy(
  () => import("src/pages/outerPages/searchPropertyDetails/searchPropertyDetailsScreen")
);


const AuthRoute: React.FC = () => {
  return (
    <AuthLayout>
      <Suspense>
        <Routes>
          <Route path="/home" element={<HomeScreen />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicyScreen />} />
          <Route path="/termsConditions" element={<TermsConditionsScreen />} />
          <Route path="/" element={<HomeScreen />} />
          <Route path="/listProperty" element={<ListPropertyScreen />} />
          <Route path="/signIn" element={<SignInScreen />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/dashboard" element={<DashboardScreen />} />
          <Route path="/propertySearch" element={<PropertySerachScreen />} />
          <Route path="/enquiryReport" element={<EnquiryReportScreen />} />
          <Route path="/smsReport" element={<SMSSettingReport />} />
          <Route path="/smsAdd" element={<SMSSettingAddScreen />} />
          <Route path="/messageSetting" element={<MessageSettingAddScreen />} />
          <Route path="/residentialPropertyDetails" element={<ResidentialPropertyDetailsScreen />} />
          <Route path="/commercialPropertyDetails" element={<CommercialPropertyDetailsScreen />} />
          <Route path="/pgPropertyInformation" element={<PgPropertyInformationScreen />} />
          <Route path="/residentialPropertyInformation" element={<RecidentialPropertyInformationScreen />} />
          <Route path="/commercialPropertyInformation" element={<CommercialPropertyInformationScreen />} />
          <Route path="/PgPropertyDetails" element={<PgPropertyDetailsScreen />} />
          <Route path="/SearchPropertyFilter" element={<SearchPropertyFilterScreen />} />
          <Route path="/SearchPropertyList" element={<SearchPropertyListScreen />} />
          <Route path="/SearchPropertyDetails" element={<SearchPropertyDetailsScreen />} />
          <Route path="/linkedin/callback" element={<LinkedInCallback />} />

        </Routes>
      </Suspense>
    </AuthLayout>
  );
};

export default AuthRoute;
